import { API_UNDERLYING_MENTIONED_URL } from "src/consts/urls";
import { useQuery } from "src/hooks/react-query/use-query";
import { IMentionedUnderlying } from "src/types/common";

type TMentionedUnderlyingResponse = IMentionedUnderlying[];

interface IRequest {
    underlyingIsins: string[];
}

export function useMentionedUnderlyingsQuery({ underlyingIsins }: IRequest) {
    return useQuery<TMentionedUnderlyingResponse>(API_UNDERLYING_MENTIONED_URL, {
        queryParams: new URLSearchParams(underlyingIsins.map(isin => ["underlyingIsins", isin])),
        retry: 0,
    });
}
